module.exports = __webpack_public_path__ + "static/Nammaflix-bb4479452ce34462e8f817bcda049208.jpg";